<template>
    <div>
        <modal @close="stopVideo" @open="videoClicked" class="video-modal">
            <div slot="modal-trigger" class="video-block">
				<transition name="fade" mode="out-in">
					<div class="video-thumb"
						:style="getVideoThumbStyle(video)">
						<slot name="video-title"></slot>
						<icon-play/>
					</div>
				</transition>
            </div>

            <div slot="modal-content" class="flex">
				<div class="video-placeholder"></div>
            </div>

        </modal>
    </div>
</template>

<script>
    import YouTube from "./YouTube";
    import Modal   from "./Modal";

    export default {
        name: "VideoModal",

        extends: YouTube,

        components: { Modal },

        props: {
            'video': String,
		},
		
        data() {
            return {
                thumbIsVisible: true,
            }
        },

        methods: {
            videoClicked() {
                this.playVideo();
                this.thumbIsVisible = false;
            },
        },

        mounted() {
            this.youtubeInit(this.video);
        }
    }
</script>

<style scoped lang="scss">
    .video-container {
        width: 100%;
    }
</style>
